import { PaymentOptions } from '@entities/amount-button/types';

export const setAmountSStorage = (value: string) => {
  sessionStorage.setItem('amount', value);
};

export const setAmountCommissionsSStorage = (info: PaymentOptions) => {
  sessionStorage.setItem('commission', JSON.stringify(info));
};
